import MarkdownIt from 'markdown-it';
import markdownItAttrs from 'markdown-it-attrs-es5';
import { markdownLinkTarget } from './markdownLinkTarget';
import { sanitiseWebChatHTML } from './sanitiseWebChatHTML';
export const buildMarkdownRenderer = (options) => {
    return (markdown) => {
        if (options.respectCRLF) {
            markdown = markdown.replace(/\n\r|\r\n/gu, (carriageReturn) => (carriageReturn === '\n\r' ? '\r\n' : '\n\r'));
        }
        const md = new MarkdownIt({
            breaks: false,
            html: false,
            linkify: true,
            typographer: true,
            xhtmlOut: true
        });
        md.use(markdownItAttrs);
        if (options.linkTargetPlugin.enabled) {
            md.use(markdownLinkTarget, options.linkTargetPlugin.config);
        }
        const html = md.render(markdown);
        return sanitiseWebChatHTML(html);
    };
};
//# sourceMappingURL=markdownRenderer.js.map